module.exports = __webpack_public_path__ + "b740b668fa0ac65cd626d78f096d168b.svg";